import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  blackShade19,
  blueColor04,
} from "../../../../../configs/styles/muiThemes";
import moment from "moment";

function ConfirmationCard3({ ondcCartData }) {
  return (
    <Stack alignItems="center" gap="15px">
      <Box
        component="img"
        src="/./assets/image/invoice-download.png"
        width="80px"
        height="80px"
      />
      <Typography
        color={blackShade19}
        fontWeight={600}
        fontSize={14}
        textAlign="center"
      >
        Invoice have been downloaded. Please take a printout and attach to the
        package
      </Typography>
      {ondcCartData?.shipmentInfo?.etaPickUpTime && (
        <Typography color={blackShade19} fontWeight={600} fontSize={14}>
          Delivery agent will arrive for pickup around{" "}
          <Typography
            color={blueColor04}
            fontWeight={600}
            fontSize={14}
            component="span"
          >
            {ondcCartData?.shipmentInfo?.etaPickUpTime
              ? moment(ondcCartData?.shipmentInfo?.etaPickUpTime).format(
                  "DD MMM, hh:mm A"
                )
              : "30 mins."}
          </Typography>
        </Typography>
      )}
    </Stack>
  );
}

export default ConfirmationCard3;
